<template>
  <div id="video">
    <div class="no-auth-header">
      <img src="../assets/thitch_logo.png" height="30" alt="thitch logo" />
    </div>
    <div class="video-wrapper">
      <mdb-container class="mx-auto video-container">
        <video class="video-fluid z-depth-1 mx-auto" poster="https://thitchstorage.blob.core.windows.net/thitchimage/Thitch_filler.jpg" controls="controls" preload="auto" >
          <source :src="data.VideoUri" type="video/mp4" />
        </video>
      </mdb-container>
    </div> 
    <mdb-container class="py-3 mx-auto w-100">
      <div class="text-left">
        <div>
          <h2>{{data.VideoTitel}}</h2>
        </div>
        <div class="description-box">
          <p>
            {{data.VideoDescription}}
          </p>
        </div>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import { mdbContainer } from "mdbvue";

export default {
  name: "video-no-auth",
  components: {
    mdbContainer
  },
  data() {
    return {
      data: null
    };
  },
  created() {
    this.getVideo(this.$route.params.id);
  },
  methods: {
    getVideo: async function(videoId) {
      console.log("id", videoId);
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      };
      let params = {
        videoId: videoId
      };

      let query = Object.keys(params)
        .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      const url =
        "https://thitch.azurewebsites.net/api/GetVideoByGuid?code=muEp7xqSEawcfs7xcIkXXW0iKhxvsQBC2aREu3XziE9tQ3xQcdCfZw==&" +
        query;
      const res = await fetch(url, requestOptions);
      const data = await res.json();
      this.data = data;
      console.log("res video ", this.data);
    }
  }
};
</script>

<style scoped>
#home {
  background-color: #ffffff;
  border: 1px solid #cccccc;
}
.video-container {
  background: #b6b6b6;
  display: flex;
}
.video-fluid {
  margin: 0 auto;
  max-height: 720px;
}
.video-wrapper {
  background: #b6b6b6;
}
.no-auth-header {
  height: 100px;
  background: #fbc02d;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%) !important;
}
.no-auth-header img{
    height: 60px;
    margin-top: 20px;
    margin-left: 20px;
}
h2 {
    margin-bottom: 20px;
    margin-top: 20px;
    font-weight: 600;
}
</style>